// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"809b9168","453":"32741f83","455":"40880c50","977":"fb3c80d0"}[chunkId] + ".chunk.js";
};